var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalkman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C5.37555 0.00716485 0.00716485 5.37555 0 12V19.5C0 20.6046 0.89543 21.5 2 21.5C3.10457 21.5 4 20.6046 4 19.5V15C4.00018 13.9812 3.2345 13.1251 2.222 13.012C2.0955 12.9982 1.99976 12.8912 2 12.764V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V12.764C21.9998 12.8911 21.9043 12.9978 21.778 13.012C20.7655 13.1251 19.9998 13.9812 20 15V19.5C20 20.6046 20.8954 21.5 22 21.5C23.1046 21.5 24 20.6046 24 19.5V12C23.9928 5.37555 18.6244 0.00716485 12 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 8H17.5C18.3284 8 19 8.67157 19 9.5V22.5C19 23.3284 18.3284 24 17.5 24H8.5C7.67157 24 7 23.3284 7 22.5V15.75C7 15.6119 6.88807 15.5 6.75 15.5H6.5C5.67157 15.5 5 14.8284 5 14V11.5C5 10.6716 5.67157 10 6.5 10H6.75C6.88807 10 7 9.88806 7 9.75V9.5C7 8.67157 7.67157 8 8.5 8ZM16.5 19V11C16.5 10.4477 16.0523 10 15.5 10H10.5C9.94772 10 9.5 10.4477 9.5 11V19C9.5 19.5523 9.94772 20 10.5 20H15.5C16.0523 20 16.5 19.5523 16.5 19Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14C14.0523 14 14.5 13.5523 14.5 13C14.5 12.4477 14.0523 12 13.5 12C12.9477 12 12.5 12.4477 12.5 13C12.5 13.5523 12.9477 14 13.5 14Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18C14.0523 18 14.5 17.5523 14.5 17C14.5 16.4477 14.0523 16 13.5 16C12.9477 16 12.5 16.4477 12.5 17C12.5 17.5523 12.9477 18 13.5 18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkman);
export default __webpack_public_path__ + "static/media/walkman.42ea0356.svg";
export { ForwardRef as ReactComponent };